export default "__VITE_ASSET__eWhtVTtI__"